import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {useSelector} from "react-redux";
import axios from "axios";

const DetailEmailInquiries = () => {

    const {id} = useParams()
    const userLogin = useSelector(state => state.userLogin)
    const {userInfo} = userLogin

    const [emails, setEmails] = useState('')

    const getSingleEmail = async () => {
        const {data} = await axios.get(`https://homesafetysolutions.pythonanywhere.com/api/home_page_contact/${id}/`, {
        // const {data} = await axios.get(`http://127.0.0.1:8000/api/home_page_contact/${id}/`, {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`
            }
        })
        setEmails(data)
        // console.log(data)
    }

    useEffect(() => {
        getSingleEmail()
    }, [])

    return (
        <div>
            <div className={"banner_heading"}>
                <h1>Email Detail: </h1>
                <div>
                    <p>Name: {emails.name}</p>
                    <p>Message: {emails.message}</p>
                    <p>Email: {emails.email}</p>
                    <p>Responded?: {emails.done}</p>
                    <br />
                    <Link className={'btn btn-primary'} to={`/home_page_contact/update/${emails.id}/`}>Update Email</Link>
                </div>
            </div>
        </div>
    );
};

export default DetailEmailInquiries;